import { useEffect, useState, useRef } from 'react';
var useExterior360 = function (_a) {
    var images = _a.images, is360Mode = _a.is360Mode;
    var _b = useState(false), hideRotatingIcon = _b[0], setHideRotatingIcon = _b[1];
    var _c = useState(0), activeImageIndex = _c[0], setActiveImageIndex = _c[1];
    var imagesCount = images.length - 1;
    var movementSensitivity = 15;
    var draggableRef = useRef(null);
    useEffect(function () {
        if (activeImageIndex !== 0 && !hideRotatingIcon) {
            setHideRotatingIcon(true);
        }
    }, [activeImageIndex, hideRotatingIcon]);
    useEffect(function () {
        if (!is360Mode)
            return;
        var incrementActiveIndex = function () {
            setActiveImageIndex(function (prev) { return (prev + 1 > imagesCount ? 0 : prev + 1); });
        };
        var decrementActiveIndex = function () {
            setActiveImageIndex(function (prev) { return (prev - 1 < 0 ? imagesCount : prev - 1); });
        };
        var handleKeyDown = function (ev) {
            if (ev.key === 'ArrowLeft') {
                decrementActiveIndex();
            }
            else if (ev.key === 'ArrowRight') {
                incrementActiveIndex();
            }
        };
        var target = draggableRef.current;
        var prevDragPosition = 0;
        var handlePointerMove = function (ev) {
            var distanceDragged = prevDragPosition - ev.clientX;
            if (distanceDragged <= -movementSensitivity) {
                prevDragPosition += movementSensitivity;
                decrementActiveIndex();
            }
            if (distanceDragged >= movementSensitivity) {
                prevDragPosition -= movementSensitivity;
                incrementActiveIndex();
            }
        };
        var handlePointerUp = function () {
            window.removeEventListener('pointermove', handlePointerMove);
            window.removeEventListener('pointerup', handlePointerUp);
        };
        var handlePointerDown = function (ev) {
            if (ev.button === 2) {
                return;
            }
            if (!hideRotatingIcon) {
                setHideRotatingIcon(true);
            }
            prevDragPosition = ev.clientX;
            window.addEventListener('pointermove', handlePointerMove, { passive: true });
            window.addEventListener('pointerup', handlePointerUp, { passive: true });
        };
        target.addEventListener('keydown', handleKeyDown, { capture: true });
        target.addEventListener('pointerdown', handlePointerDown, { capture: true });
        return function () {
            target.removeEventListener('keydown', handleKeyDown, { capture: true });
            target.removeEventListener('pointerdown', handlePointerDown, { capture: true });
            window.removeEventListener('pointerup', handlePointerUp);
            window.removeEventListener('pointermove', handlePointerMove);
        };
    }, [imagesCount, movementSensitivity, is360Mode, hideRotatingIcon]);
    return {
        draggableRef: draggableRef,
        activeImageIndex: activeImageIndex,
        currentImage: images && images[activeImageIndex],
        hideRotatingIcon: hideRotatingIcon,
    };
};
export default useExterior360;
